import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface SidebarProps {
  activeKey?: "dashboard" | "itaxquest" | "eci" | "formc" | "feedback";
}

export default function Sidebar({ activeKey = "dashboard" }: SidebarProps) {
  const navigate = useNavigate();

  const [openCompMenu, setOpenCompMenu] = useState(
    activeKey === "eci" || activeKey === "formc"
  );

  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target as Node)) {
        setOpenCompMenu(false);
      }
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const navItemStyle = (active: boolean): React.CSSProperties => ({
    padding: "12px 16px",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: active ? 600 : 500,
    color: active ? "#60a5fa" : "#9ca3af",
    background: active ? "#111317" : "transparent",
  });

  const iconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    objectFit: "contain",
    flex: "0 0 16px",
  };

  return (
    <aside
      style={{
        width: 240,
        background: "#101010",
        borderRight: "1px solid #333",
        padding: 24,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 50,
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* TOP */}
      <div>
        {/* LOGO */}
        <div style={{ marginBottom: 40 }}>
          <img
            src="/logo.png"
            alt="logo"
            style={{ height: 40, width: 99, marginLeft: 5 }}
          />
        </div>

        {/* NAV */}
        <nav style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div
            style={navItemStyle(activeKey === "dashboard")}
            onClick={() => navigate("/preparer")}
          >
            <img src="/Dashboard.png" style={iconStyle} />
            Dashboard
          </div>

          <div
            style={navItemStyle(activeKey === "itaxquest")}
            onClick={() => navigate("/itaxquest")}
          >
            <img src="/iTaxQuest.png" style={iconStyle} />
            iTaxQuest
          </div>

          {/* iTaxComp */}
          <div ref={menuRef}>
            <div
              style={navItemStyle(activeKey === "eci" || activeKey === "formc")}
              onClick={() => setOpenCompMenu((v) => !v)}
            >
              <img src="/iTaxComp.png" style={iconStyle} />
              iTaxComp
              <span style={{ marginLeft: "auto" }}>
                {openCompMenu ? "▾" : "▸"}
              </span>
            </div>

            {openCompMenu && (
              <div
                style={{
                  marginLeft: 28,
                  marginTop: 6,
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                }}
              >
                <div
                  onClick={() => navigate("/eci")}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    fontSize: 13,
                    cursor: "pointer",
                    color: activeKey === "eci" ? "#60a5fa" : "#9ca3af",
                    background:
                      activeKey === "eci"
                        ? "rgba(59,130,246,0.12)"
                        : "transparent",
                    fontWeight: activeKey === "eci" ? 600 : 500,
                  }}
                >
                  ECI
                </div>

                <div
                  onClick={() => navigate("/formc")}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    fontSize: 13,
                    cursor: "pointer",
                    color: activeKey === "formc" ? "#60a5fa" : "#9ca3af",
                    background:
                      activeKey === "formc"
                        ? "rgba(59,130,246,0.12)"
                        : "transparent",
                    fontWeight: activeKey === "formc" ? 600 : 500,
                  }}
                >
                  Form C / C-S / C-S (Lite)
                </div>
              </div>
            )}
          </div>

          <div style={navItemStyle(false)}>
            <img src="/Notifications.png" style={iconStyle} />
            Notifications
          </div>

          <div
            style={navItemStyle(activeKey === "feedback")}
            onClick={() => navigate("/feedback")}
          >
            <img src="/Feedback.png" style={iconStyle} />
            Feedback
          </div>
        </nav>
      </div>

      {/* USER CARD (UPDATED) */}
      <div
  style={{
    width: 150,
    height: 234,
    borderRadius: 20,
    background: "linear-gradient(180deg, #1b1b1b 0%, #0f0f0f 100%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 12px",
    boxSizing: "border-box",
    alignSelf: "center",
    position: "relative", // ✅ key
    top: -30,              // ✅ moves UP only
  }}
>

        {/* Profile */}
        <div
          style={{
            width: 52,
            height: 52,
            borderRadius: "50%",
            overflow: "hidden",
            border: "2px solid #2f2f2f",
          }}
        >
          <img
            src="/Adminavatar.jpg"
            alt="profile"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        {/* Name + Email */}
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#fff",
              marginBottom: 2,
            }}
          >
            Admin
          </div>
          <div
            style={{
              fontSize: 12,
              color: "#9ca3af",
              maxWidth: 120,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            enquiry@itax.sg
          </div>
        </div>

        {/* Logout */}
        <button
          onClick={() => console.log("Logout")}
          style={{
            width: 54,
            height: 54,
            borderRadius: "100%",
            border: "1px solid #2f2f2f",
            background: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <img src="/logout.png" style={{ width: 28, height: 28 }} />
        </button>
      </div>
    </aside>
  );
}
